import { useEffect, useState } from 'react';

import { Flex, MenuItem } from '@vimeo/bokeh';
import { HeartFilled } from '@vimeo/bokeh-icons';
import { translate } from '@vimeo/i18n-runtime';

const replacements = {
  ICON: <HeartFilled key="heart-filled" color="red.500" marginX="xs" />,
};

const cities: string[] = [
  translate({
    singular: 'Made with {ICON} in Bangalore',
    replacements,
  }),
  translate({
    singular: 'Made with {ICON} in Tel Aviv',
    replacements,
  }),
  translate({
    singular: 'Made with {ICON} in NYC',
    replacements,
  }),
  translate({
    singular: 'Made with {ICON} in Zaporizhzhia',
    replacements,
  }),
  translate({
    singular: 'Made with {ICON} in London',
    replacements,
  }),
  translate({
    singular: 'Made with {ICON} at home',
    replacements,
  }),
  translate({
    singular: 'Made with {ICON} in Kyiv',
    replacements,
  }),
];

export const MadeWithLoveAnimated = () => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCount((prevCount) => prevCount + 1);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  const city = cities[count % cities.length];

  return (
    <MenuItem _hover={{ bg: 'transparent', _dark: { bg: 'transparent' } }} cursor="default">
      <Flex alignItems="center">{city}</Flex>
    </MenuItem>
  );
};
